import { Tooltip } from '@mui/material';

export function percentileColor(percentile) {
  if (Number.isNaN(percentile) || percentile < 0) {
    return 'primary'; // Grey for NaN / negative
  }
  if (percentile > 80) {
    return 'success'; // Green color for values above 80
  }
  if (percentile > 50) {
    return 'warning'; // Yellow color for values between 50 and 80
  }
  return 'error'; // Red color for values below or equal to 50
}

export const TooltipHeader = ({ tooltip, content }) => (
  <Tooltip title={tooltip} placement="top">
    {content}
  </Tooltip>
);
